module.exports = __webpack_public_path__ + "img/US_Heal_ua.dbc22fe9.webp";